<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_TASK_TYPE')" :vertical="false" :required="true" />
          </div>
          <div class="col-xs-5">
            <cmp-task-id-select
              ref="taskIdSelect"
              :default1LevelOption="'all'"
              :default2LevelOption="'all'"
              :default3LevelOption="'all'"
              :pageId="this.$options.name"
              applyAuthType="D"
              @select-changed="onChangeBizCodes"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_PIC')" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-text-field v-model="searchUserName" maxlength="50" @keyup.enter="onSearch" />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_DELG_USER')" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-text-field v-model="searchRegUserName" maxlength="50" @keyup.enter="onSearch" />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onReset"
          >{{ $t('MSG_BTN_RESET') }}</sui-button>
          <sui-button
            v-permission:read="'PGE_CMA_00008'"
            type="button"
            class="comm_btn_Scr"
            @click="onSearch"
          >{{ $t('MSG_BTN_SEARCH') }}</sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grdList"
        :showDisplayCountControl="false"
        :pageable="false"
        :columns="gridColumns"
        :multiselect="true"
        :initialPagesize="10"
        width="100%"
        :dataset="'dsData'"
      />
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:delete="'PGE_CMA_00008'"
          type="button"
          class="comm_btn_border"
          @click="onDelete"
        >{{ $t('MSG_BTN_DEL') }}</sui-button>
        <sui-button
          v-permission:create="'PGE_CMA_00008'"
          type="button"
          class="comm_btn_solid"
          @click="onAdd"
        >{{ $t('MSG_BTN_RGST') }}</sui-button>
      </div>
      <sui-popup v-model="showRegPopup" :title="$t('MSG_TIT_AUTH_DELG_ADD')">
        <regDelgAdd
          :parentPageId="this.$options.name"
          @save="onPopupSaveClicked"
          @cancel="onPopupCancelClicked"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
// 페이지 에서 사용하는 code 목록 기술
import regDelgAdd from './components/PGE_CMA_00008_P01';

export default {
  name: 'PGE_CMA_00008', // eslint-disable-line vue/name-property-casing
  components: {
    regDelgAdd,
  },
  data() {
    return {
      searchUserName: '',
      searchRegUserName: '',
      sessionInfo: {},
      showRegPopup: false,
      selectedBizCode: [],
      selectedCode: {
        SIT: { key: '', label: '' },
      },
      localdata: [],
      gridColumns: [
        {
          text: this.$t('MSG_TXT_TASK_TYPE'),
          datafield: 'taskName',
        },
        {
          text: this.$t('MSG_TXT_PIC'),
          datafield: 'authApprDlgtnUserId',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellUserName(
              row,
              column,
              value,
              htmlElement,
              {
                displayType: '1', // "1", "2" - default: "1"
                type: 'link', // 'link', 'sublink' - default: "link"
                datafieldMap: {
                  displayLanguageId: 'dsplLangId',
                  knoxId: 'knoxId',
                  loginId: 'loginId',
                  userName: 'userName',
                  userGlobalName: 'userGlobalName',
                },
              },
              this.dsData,
              this.$refs.grdList,
            );
          },
          initwidget(row, column, value, htmlElement) {
            utils
              .getGridCellFactory()
              .refreshCell(row, column, value, htmlElement);
          },
          width: 200,
        },
        {
          text: this.$t('MSG_TXT_DELG_USER'),
          datafield: 'firstRegistrationUserId',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellUserName(
              row,
              column,
              value,
              htmlElement,
              {
                displayType: '1', // "1", "2" - default: "1"
                type: 'link', // 'link', 'sublink' - default: "link"
                datafieldMap: {
                  displayLanguageId: 'firstRegistrationDsplLangId',
                  knoxId: 'firstRegistrationKnoxId',
                  loginId: 'firstRegistrationLoginId',
                  userName: 'firstRegistrationUserName',
                  userGlobalName: 'firstRegistrationUserGlobalName',
                },
              },
              this.dsData,
              this.$refs.grdList,
            );
          },
          initwidget(row, column, value, htmlElement) {
            utils
              .getGridCellFactory()
              .refreshCell(row, column, value, htmlElement);
          },
          width: 200,
        },
        {
          text: this.$t('MSG_TXT_DELG_DTM'),
          datafield: 'firstRegistrationDTM',
          createwidget: (r, c, v, h) =>
            utils
              .getGridCellFactory()
              .createCellDateLabel(r, c, v, h, this.dsData, this.$refs.grdList),
          initwidget: (r, c, v, h) =>
            utils.getGridCellFactory().refreshCell(r, c, v, h),
          width: 150,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  datasets: [
    {
      id: 'dsData',
      type: 'local',
      data: 'localdata',
      datafields: [
        // { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
        {
          name: 'authApprDlgtnUserId',
          type: 'string',
          map: 'authApprDlgtnUserId',
        },
        { name: 'userName', type: 'string', map: 'userName' },
        { name: 'taskId', type: 'string', map: 'taskId' },
        { name: 'taskName', type: 'string', map: 'taskName' },
        { name: 'userGlobalName', type: 'string', map: 'userGlobalName' },
        { name: 'knoxId', type: 'string', map: 'knoxId' },
        { name: 'loginId', type: 'string', map: 'loginId' },
        { name: 'dsplLangId', type: 'string', map: 'dsplLangId' },
        {
          name: 'firstRegistrationDTM',
          type: 'string',
          map: 'firstRegistrationDTM',
        },
        {
          name: 'firstRegistrationUserId',
          type: 'string',
          map: 'firstRegistrationUserId',
        },
        {
          name: 'firstRegistrationUserName',
          type: 'string',
          map: 'firstRegistrationUserName',
        },
        {
          name: 'firstRegistrationUserGlobalName',
          type: 'string',
          map: 'firstRegistrationUserGlobalName',
        },
        {
          name: 'firstRegistrationDsplLangId',
          type: 'string',
          map: 'firstRegistrationDsplLangId',
        },
        {
          name: 'firstRegistrationKnoxId',
          type: 'string',
          map: 'firstRegistrationKnoxId',
        },
        {
          name: 'firstRegistrationLoginId',
          type: 'string',
          map: 'firstRegistrationLoginId',
        },
      ],
    },
  ],
  mounted() {
    this.sessionInfo = this.$store.getters.userInfo;
    this.selectedCode.SIT.key = 'ALL';
    this.load();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    load() {},
    onListClicked(event, item) {
      this.$refs.taskIdSelect.reset();
    },
    onChangeBizCodes(optList) {
      this.selectedBizCode = optList;
    },
    onReset() {
      this.$refs.taskIdSelect.reset('ALL');
      this.selectedBizCode = [];
      this.searchUserName = '';
      this.searchRegUserName = '';
      this.load();
    },
    onSearch() {
      let taskId = '';
      if (this.selectedBizCode.length === 3) {
        if (this.selectedBizCode[2].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[2].key);
        } else if (this.selectedBizCode[1].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[1].key);
        } else if (this.selectedBizCode[0].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[0].key);
        }
      }

      const queryParams = {
        taskId: taskId || '',
        searchUserName: this.searchUserName || '',
        searchRegUserName: this.searchRegUserName || '',
      };

      http
        .request(this.$options.name, 'DTS_CMA_00027', {
          query: queryParams,
        })
        .then(res => {
          if (res.data) {
            this.dsData.setRawData(res.data);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    onAdd() {
      this.showRegPopup = true;
    },
    onDelete() {
      const indexes = this.dsData.getSelectedIndexes();
      if (utils.isEmpty(indexes)) {
        utils.messageBox('warning', this.$t('MSG_ALT_DEL_NO_DATA'));
        return;
      }
      utils.messageBox(
        'confirm',
        this.$t('MSG_ALT_IS_DEL_DATA'),
        null,
        this.deleteDatas,
      );
    },
    onPopupSaveClicked() {
      // this.dsData.addRows([dataInfo]);
      this.showRegPopup = false;
      this.onSearch();
    },
    onPopupCancelClicked() {
      this.showRegPopup = false;
    },
    onSelectGrid(oldSelections, newSelections) {
      console.log(newSelections);
    },
    deleteDatas() {
      const indexes = this.dsData.getSelectedIndexes();
      const dataParams = [];
      utils.forEach(indexes, index => {
        const selectedData = this.dsData.data[index];
        dataParams.push({
          authApprDlgtnUserId: selectedData.authApprDlgtnUserId,
          taskId: selectedData.taskId,
        });
      });

      http
        .request(this.$options.name, 'DTS_CMA_00030', {
          data: dataParams,
        })
        .then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_DEL_DATA'));
          this.onSearch();
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
</style>
